import { render, staticRenderFns } from "./HotNewGoods.vue?vue&type=template&id=b951d96c&scoped=true&"
import script from "./HotNewGoods.vue?vue&type=script&lang=js&"
export * from "./HotNewGoods.vue?vue&type=script&lang=js&"
import style0 from "./HotNewGoods.vue?vue&type=style&index=0&id=b951d96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b951d96c",
  null
  
)

export default component.exports